var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"crossfade-container"}},[_c('section',{attrs:{"id":"crossfade"},on:{"drag":_vm.crossFade}})])
}
var staticRenderFns = []

export { render, staticRenderFns }